import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postHealthOneStart,
  postHealthOneSuccess,
  postHealthOneDataSuccess,
  postHealthOneFailure,
} from "../reducers/postHealthOneReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postHealthOne = createAsyncThunk(
  "postHealthOne",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postHealthOneStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/Health/SaveHealthFirstPage`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set content type if necessary
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postHealthOneSuccess(responseData?.data?.result));
      thunkAPI.dispatch(postHealthOneDataSuccess(values));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postHealthOneFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postHealthOneFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postHealthOneFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
